var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ca-identifier ca-option",class:{ chosen: _vm.chosen },on:{"click":function($event){return _vm.clickIdentifier(_vm.identifier)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }